import { render, staticRenderFns } from "./BlacklistedResourcesView.vue?vue&type=template&id=61272a2f&"
import script from "./BlacklistedResourcesView.js?vue&type=script&lang=js&"
export * from "./BlacklistedResourcesView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports